import { render, staticRenderFns } from "./AddManager.vue?vue&type=template&id=2cb960d7&scoped=true&"
import script from "./AddManager.vue?vue&type=script&lang=js&"
export * from "./AddManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb960d7",
  null
  
)

export default component.exports